import React, { createContext, useState, useContext } from 'react';
const StockModalContext = createContext();

export const StockModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [symbol, setSymbol] = useState(null);

  const openStockModal = (sym) => { setSymbol(sym); setIsOpen(true); };
  const closeStockModal = () => { setIsOpen(false); setSymbol(null); };

  return (
    <StockModalContext.Provider value={{ isOpen, symbol, openStockModal, closeStockModal }}>
      {children}
    </StockModalContext.Provider>
  );
};
export const useStockModal = () => useContext(StockModalContext);
